import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  checkboxList: {
    backgroundColor: palette.shades[100],
    padding: '16px 24px',
    '& .MuiFormControlLabel-label': {
      marginLeft: '2px'
    }
  },
  subCheckboxes: {
    borderLeft: "1px dashed ".concat(palette.shades[600]),
    paddingLeft: '24px',
    marginLeft: '4px',
    marginTop: '10px'
  },
  listAccordionDetails: {
    paddingLeft: '13px'
  },
  blankCheckbox: {
    display: 'inline-block',
    '& path': {
      fill: palette.shades[600]
    }
  },
  activeCheckbox: {
    display: 'inline-block',
    '& path': {
      fill: palette.primary.main
    }
  },
  listAccordion: {
    padding: '16px 24px',
    marginTop: '4px',
    '& + &': {
      marginTop: '4px'
    },
    '&.Mui-expanded': {
      marginTop: '4px',
      marginBottom: '0'
    },
    '& .MuiAccordionSummary-root': {
      flexDirection: 'row-reverse'
    },
    '& .MuiCollapse-root': {
      borderTop: 'none'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: '8px',
      marginLeft: '2px'
    }
  },
  plainListHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  plainListArrow: {
    marginLeft: '-11px',
    marginRight: '8px',
    '& path': {
      fill: palette.shades[400]
    }
  }
});
export default useStyles;